import React, { useEffect, useRef, useState } from 'react'
// import ZoomMtgEmbedded from '@zoom/meetingsdk/embedded'
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import styles from "./HostMeeting.module.css"
import Zoom from './Zoom';
import api from '../helper/Api';
import { useSelector } from 'react-redux';

const HostMeeting = () => {
    const navigate = useNavigate();
    const [signature, setSignature] = useState(null);
    const { id } = useParams()

    const queryParams = new URLSearchParams(window.location.search);
    const mn = id;
    const pw = queryParams.get("meetingPassword");
    const role = "0";


    const fetchSignature = async () => {
        try {
            const { data } = await api.getSignature({
                meetingId: mn,
                role: parseInt(role, 10),
            })

            setSignature(data?.data)
        } catch (error) {
            console.error("Error fetching signature:", error);
            // throw error; // Rethrow the error for further handling
        }
    };

    return (
        <div style={{ minHeight: "90vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            {
                signature ? <Zoom signature={signature} id={id} />
                    : <button onClick={fetchSignature} className={styles.button}>Join Meeting</button>
            }
        </div>
    )
}

export default HostMeeting